module.exports = [{"uuid":1,"username":"test"},{"uuid":2,"username":"adrian"},{"uuid":3,"username":"fran"},{"uuid":4,"username":"diego"},{"uuid":5,"username":"sergio"}]


//////////////////
// WEBPACK FOOTER
// ./src/data/mocks/superadmin/mcList.json
// module id = ./src/data/mocks/superadmin/mcList.json
// module chunks = 0